const ROUTES = {
  ROOT:            "/",

  // Auth Routes
  LOGIN:           "/login",
  LOGOUT:          "/logout",

  // Drawer Routes
  DASHBOARD:       "/dashboard",
  ANALYTICS:       "/analytics",
  DEALER:          "/dealer-management",
  ORDERS:          "/orders",
  INVENTORY:       "/inventory",
  VEHICLES:        "/inventory/vehicles",
  BATTERIES:       "/inventory/batteries",
  ADDVEHICLE:      "/inventory/vehicles/addvehicle",
  ADDBATTERY:      "/inventory/batteries/addbattery",
  BATTERY_DETAIL:  "/inventory/batteries/:bId",
  VEHICLE_DETAIL:  "/inventory/vehicles/:vId",
  ADDCLIENT:       "/lease/addclient",
  SETTINGS:        "/settings",
  PROFILE:         "/settings/profile",
  MODELS:          "/settings/models",
  CLIENTS:         "/settings/clients",
  ADDMODEL:        "/settings/models/add",
  NOTIFICATIONS:   "/notifications",
  LEASE:           "/lease",
  LEASED_VEHICLES: "/lease/vehicles",
  LEASE_VEHICLES:  "/lease/vehicles/lease-vehicles",
  ADD_GEOFENCE:    "/lease/vehicles/add-geofence",
  VIEW_GEOFENCES:  "/lease/vehicles/view-geofences",
  VEHICLE_STATS:   "vehicle-stats",
  PAST_RIDES:      "past-rides",
  RIDE_DETAILS:    "ride-details",

  DRIVERS:         "drivers",
  ADD_DRIVERS:     "drivers/add",

  REPORTS:              "reports",
  // Analytics Routes
  MOTOR_TEMPERATURE:    "motor-temperature",
  MOTOR_STATUS:         "motor-status",
  AVERAGE_RUNNING:      "average-running",
  BATTERY_TEMPERATURE:  "battery-temperature",
  BATTERY_VOLTAGE:      "battery-voltage",
  CHARGE_CYCLE:         "charge-cycle",
  THROTTLE_PERCENT:     "throttle-percent",
  BATTERY_HEALTH:       "battery-health",

  // Drivers
  DRIVER_STATS:         "driver-stats",

  // LEASE
  PAYMENTS:         "payments",

  // Wallet
  TRANSACTION_DETAILS: "transaction-details",

  // routes for dealers
  SHOW_DEALERS: "/show-dealers",
  ADD_DEALER: "/show-dealers/add-dealer",
  SPECIFIC_DEALER: "dealer-profile",
  EDIT_DEALER: "edit-dealer",

  // routes for inventory
  MANAGE_INVENTORY: "/manage-inventory",
  DEVICES: "devices",
  SPECIFIC_DEVICE: "specific-device",
  MAP_TO_VEHICLE: "map-to-vehicle",

  // Dealers / Client Management
  DEALERS_OVERVIEW: "/dealers-overview",
  ORDER_DETAIL: "order-detail",
  ORDERS_OVERVIEW: "/orders-overview",
  INVENTORY_OVERVIEW: "/inventory-overview",
  INSTALLATION_VIDEO: "/installation-video",
  OEM_DEALERS:"oem-dealers",
  SHIPPING_DETAILS: "shipping-details",
  SHIPMENT_STATUS: "shipment-status",
  SHIPMENT_OVERVIEW: "/shipment-overview",

  //  User Login
  LIVE_TRACKING: "/live-tracking",
  // STATISTICS: "/statistics",
  SET_ALERTS: "/set-alerts",

  ALL_VEHICLE_STATS: "/all-vehicle-stats",
  SINGLE_VEHICLE_STATS: "single-vehicle-stats",
  ALERTS: "alerts",
  ADD_GEOFENCE_ALERT: "add-geofence-alert",
  ADD_OVERSPEED_ALERT: "add-over-speed-alert",
  SET_ROUTES: "/set-routes",
  VIEW_ROUTES: "/view-routes",
  VIEW_STATS: "view-stats",
  VEHICLE_ACTIVITY: "/vehicle-activity",

  // SUB USER PATHS
  SUB_USERS: "/sub-users",
  CREATE_SUB_USER: "create-subUser",
  SUB_USER_DETS: "sub-user-details",
  ASSIGN_VEHICLES: "assign-vehicles",
};

export default ROUTES;
